import React, { useState } from 'react';
import styles from './index.module.scss';
import { showError, showSuccess } from 'utils';
import { addKeywords } from 'services';

const AddItemKeywordsModal = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [keywords, setKeywords] = useState<string>('');
  const [keywordsArray, setKeywordsArray] = useState<string[]>([]);
  const { itemId, onSuccess, toggleModal } = props;

  const addKeywordsFn = async () => {
    setLoading(true);
    try {
      const { keywords } = (await addKeywords({
        id: itemId,
        keywords: keywordsArray,
      })).toJSON();
      await onSuccess(keywords);
      showSuccess('Keywords added successfully');
      toggleModal();
    } catch (e) {
      showError(e);
      setLoading(false);
    }
  };

  const handleChange = (keywordsInputValue: string) => {
    setKeywords(keywordsInputValue)
    setKeywordsArray(keywordsInputValue.split(',').map(keyword => keyword.trim()));
  };
  
  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Inventory Item</div>
            <div className={styles['modal-title']}>Add Keywords</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Keywords</div>
            <textarea
              disabled={loading}
              value={keywords}
              className={'form-control'}
              onChange={e => handleChange(e.target.value)}
            />
            <div className={styles['helper-text']}>Use commas to separate keywords</div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={addKeywordsFn}
            className={styles['submit-button']}
            disabled={loading || !keywords}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddItemKeywordsModal;
